import { useEffect } from 'react';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom';
import {
  Box,
  TextField,
  IconButton,
  InputAdornment,
  AppBar,
  Toolbar,
  Container,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useLang } from '../contexts/langContext';
import { useMaterials } from '../hooks/useMaterials';
import MaterialSearchResults from '../components/materials/MaterialSearchResults';
import { useAppContext } from '../contexts/AppContext';

function MaterialSearchPage() {
  const { id: projectId } = useParams();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const { lang } = useLang();
  const initialQuery = searchParams.get('q') || '';
  const { setAppTitle } = useAppContext();
  useEffect(() => {
    setAppTitle(lang === 'en' ? 'Material Search' : '素材搜索');
  }, []);

  const {
    materials,
    searchQuery,
    isSearching,
    setSearchQuery,
    handleSearch,
    deleteMaterial,
    toggleMaterialEnabled,
  } = useMaterials({ projectId, initialFetch: false });

  useEffect(() => {
    if (initialQuery) {
      setSearchQuery(initialQuery);
      handleSearch();
    }
  }, [initialQuery]);

  const handleSearchSubmit = () => {
    setSearchParams({ q: searchQuery });
    handleSearch();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Box>
      <AppBar position="sticky" color="default" elevation={1}>
        <Toolbar>
          <IconButton edge="start" onClick={handleBack} aria-label="back">
            <ArrowBackIcon />
          </IconButton>
          <Box sx={{ flexGrow: 1, ml: 2 }}>
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              placeholder={lang === 'en' ? 'Search materials...' : '搜索材料...'}
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSearchSubmit()}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleSearchSubmit} disabled={isSearching}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Box>
        </Toolbar>
      </AppBar>

      <Container maxWidth="md">
        <MaterialSearchResults 
          projectId={projectId}
          materials={materials}
          searchQuery={searchQuery}
        />
      </Container>
    </Box>
  );
}

export default MaterialSearchPage; 